const Test = () => import('../views/Test.vue')
export default [
  {
    path: 'tests',
    component: Test,
    meta: { requiresAuth: true },
    name: 'partner.tests'
  },
  
]